import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  AuditSearchRequest,
  AuditSearchResponse,
  Transaction,
  TransactionSearchRequest,
  TransactionSearchResponse,
  TransactionStats,
} from "./@types";

export const subscriptionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.mutation<
      ApiSuccessResponse<TransactionSearchResponse>,
      TransactionSearchRequest
    >({
      query: (data) => ({
        url: "/v1/transaction/transaction/all",
        method: "POST",
        body: { ...data },
      }),
    }),
    getTransactionStats: builder.query<
      ApiSuccessResponse<TransactionStats>,
      void
    >({
      query: () => ({
        url: "/v1/transaction/TransactionStats",
        method: "GET",
      }),
    }),
    getTransactionById: builder.query<ApiSuccessResponse<Transaction>, string>({
      query: (id) => ({
        url: `/v1/transaction/transaction/${id}`,
        method: "GET",
      }),
    }),
    getCompanyAudit: builder.mutation<
      ApiSuccessResponse<AuditSearchResponse>,
      AuditSearchRequest
    >({
      query: (data) => ({
        url: "/audit/company-audit",
        method: "POST",
        body: { ...data },
      }),
    }),
  }),
});

export const {
  useGetTransactionsMutation,
  useGetTransactionStatsQuery,
  useGetTransactionByIdQuery,
  useGetCompanyAuditMutation,
} = subscriptionApiSlice;
